import React from "react";
import * as Routes from "./routes/Routes";
import configRouters from "Configs/routes";
import { Route, Switch } from "react-router-dom";
import { inject, observer } from "mobx-react";

@inject("ApplicationModel")
@observer
class Partner extends React.Component {
	render() {
		return (
			<Switch>
				<Route exact path={configRouters.Partner.route} component={Routes.Partner} />
			</Switch>
		);
	}
}

export default Partner;
